import { Component, HostBinding, OnInit } from '@angular/core';
import { ClientService } from '../client.service';
import { Paginator } from 'app/models/paginator';
import { Client } from '../../models/client';
import { EditClientModalComponent } from '../edit-client-modal/edit-client-modal.component';
import { ModalService } from '../../core/modal.service';

@Component({
  selector: 'cw-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {
  @HostBinding('class') className = 'content-container';
  paginator: Paginator<Client>;
  isLoading: boolean;

  constructor(private clientService: ClientService,
              private modal: ModalService) {
  }

  ngOnInit() {
    this.loadClients();
  }

  showCreateClient() {
    const modalRef = this.modal.open(EditClientModalComponent);
    modalRef.componentInstance.initCreate();
    modalRef.result.then(client => {
      this.loadClients();
    }).catch(() => {
    });
  }

  private loadClients() {
    this.isLoading = true;
    this.clientService.get().subscribe(paginator => {
      this.paginator = paginator;
      this.isLoading = false;
    });
  }

  get clients() {
    return this.paginator && this.paginator.items;
  }

}



// WEBPACK FOOTER //
// ./src/app/clients/client-list/client-list.component.ts